import React from "react";
import ProfilesAndSettings from "views/Config/Profiles/Common";
import timeComposition from "./composition";
import { composedAPI } from "./api";
import help from "help/viewTimeProfileConfig.md";
import settingsHelp from "help/viewTimeProfileConfigSettings.md";

const ConfigTimeProfiles = ({ ...settings }) => (
  <ProfilesAndSettings
    {...timeComposition}
    {...composedAPI}
    {...settings}
    help={help}
    settingsHelp={settingsHelp}
  />
);

export default ConfigTimeProfiles;
